// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__7VapX","table":"Table_table__iBb+j","striped":"Table_striped__atNZ8","hover":"Table_hover__xCJwu","num":"Table_num__GsdVz"};